"use client";

import { useAtomValue, useSetAtom } from "jotai";
import { PropsWithChildren, useCallback } from "react";
import { ShowItemIndex } from "./Pannel";
import { cn } from "@/lib/utils";
import RouterLink from "@/components/ui/router-link";
import { useThrottleFn } from "ahooks";

export function HoverItem(
  props: PropsWithChildren<{
    href?: string;
    index: number;
    className?: string;
    activeClassName?: string;
  }>
) {
  const setShowItemIndex = useSetAtom(ShowItemIndex);
  const showIndex = useAtomValue(ShowItemIndex);

  const { run } = useThrottleFn(
    () => {
      if (props.index === showIndex) return;

      setShowItemIndex(props.index);
    },
    {
      wait: 1000,
    }
  );

  // const run = useCallback(() => {
  //   if (props.index === showIndex) return;

  //   setShowItemIndex(props.index);
  // }, [props.index, setShowItemIndex, showIndex]);

  return (
    <RouterLink
      href={props.href}
      onMouseEnter={run}
      className={cn(
        props.className,
        props.index === showIndex && props.activeClassName
      )}>
      {props.children}
    </RouterLink>
  );
}
